document.addEventListener('facet:rendered', function(event) {
    /* Already done in facets.js
      if (window.location.href.includes("filter.v.option.tamaño") && !window.location.href.includes("filter.v.availability")) {
        window.location.href = `${window.location.href}&filter.v.availability=1`
        console.log("actualizado");
      }
      console.log("actualizar");
  */
});
document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('recycled_package').addEventListener('change', function (event) {
    const recycledPackageValue = event.target.checked ? 'Si' : 'No';
    document.getElementById('recycled_package').setAttribute('value', recycledPackageValue);
    document.querySelector('#CartDrawer-Form').setAttribute('data-recycled-package', recycledPackageValue);
  });
});